// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type BusinessFunctionTypeQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type BusinessFunctionTypeQuery = { __typename?: 'Query', enumDetails: { __typename?: 'AllEnumDetails', businessFunctionType: Array<{ __typename?: 'BusinessFunctionTypeDetail', code: Types.BusinessFunctionType, name: string }> } };

export type SaveGlobalPlanMilestoneGroupMutationVariables = Types.Exact<{
  input: Types.SaveGlobalMilestoneGroupInput;
}>;


export type SaveGlobalPlanMilestoneGroupMutation = { __typename?: 'Mutation', saveGlobalPlanMilestoneGroup: { __typename?: 'SaveGlobalPlanMilestoneGroupResult', globalPlanMilestoneGroup: { __typename?: 'GlobalPlanMilestoneGroup', id: string } } };


export const BusinessFunctionTypeDocument = gql`
    query BusinessFunctionType {
  enumDetails {
    businessFunctionType {
      code
      name
    }
  }
}
    `;

/**
 * __useBusinessFunctionTypeQuery__
 *
 * To run a query within a React component, call `useBusinessFunctionTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useBusinessFunctionTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBusinessFunctionTypeQuery({
 *   variables: {
 *   },
 * });
 */
export function useBusinessFunctionTypeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BusinessFunctionTypeQuery, BusinessFunctionTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BusinessFunctionTypeQuery, BusinessFunctionTypeQueryVariables>(BusinessFunctionTypeDocument, options);
      }
export function useBusinessFunctionTypeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BusinessFunctionTypeQuery, BusinessFunctionTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BusinessFunctionTypeQuery, BusinessFunctionTypeQueryVariables>(BusinessFunctionTypeDocument, options);
        }
export function useBusinessFunctionTypeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BusinessFunctionTypeQuery, BusinessFunctionTypeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BusinessFunctionTypeQuery, BusinessFunctionTypeQueryVariables>(BusinessFunctionTypeDocument, options);
        }
export type BusinessFunctionTypeQueryHookResult = ReturnType<typeof useBusinessFunctionTypeQuery>;
export type BusinessFunctionTypeLazyQueryHookResult = ReturnType<typeof useBusinessFunctionTypeLazyQuery>;
export type BusinessFunctionTypeSuspenseQueryHookResult = ReturnType<typeof useBusinessFunctionTypeSuspenseQuery>;
export type BusinessFunctionTypeQueryResult = Apollo.QueryResult<BusinessFunctionTypeQuery, BusinessFunctionTypeQueryVariables>;
export const SaveGlobalPlanMilestoneGroupDocument = gql`
    mutation SaveGlobalPlanMilestoneGroup($input: SaveGlobalMilestoneGroupInput!) {
  saveGlobalPlanMilestoneGroup(input: $input) {
    globalPlanMilestoneGroup {
      id
    }
  }
}
    `;
export type SaveGlobalPlanMilestoneGroupMutationFn = Apollo.MutationFunction<SaveGlobalPlanMilestoneGroupMutation, SaveGlobalPlanMilestoneGroupMutationVariables>;

/**
 * __useSaveGlobalPlanMilestoneGroupMutation__
 *
 * To run a mutation, you first call `useSaveGlobalPlanMilestoneGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveGlobalPlanMilestoneGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveGlobalPlanMilestoneGroupMutation, { data, loading, error }] = useSaveGlobalPlanMilestoneGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveGlobalPlanMilestoneGroupMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveGlobalPlanMilestoneGroupMutation, SaveGlobalPlanMilestoneGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveGlobalPlanMilestoneGroupMutation, SaveGlobalPlanMilestoneGroupMutationVariables>(SaveGlobalPlanMilestoneGroupDocument, options);
      }
export type SaveGlobalPlanMilestoneGroupMutationHookResult = ReturnType<typeof useSaveGlobalPlanMilestoneGroupMutation>;
export type SaveGlobalPlanMilestoneGroupMutationResult = Apollo.MutationResult<SaveGlobalPlanMilestoneGroupMutation>;
export type SaveGlobalPlanMilestoneGroupMutationOptions = Apollo.BaseMutationOptions<SaveGlobalPlanMilestoneGroupMutation, SaveGlobalPlanMilestoneGroupMutationVariables>;